import React from 'react';
import { Link } from 'react-router-dom'; // Use Link for internal navigation
import { SUPPORT_LINKS } from '../../config/appConfig';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-dark-700 text-gray-400 py-8 px-6 lg:px-8 mt-12 border-t border-dark-500">
            <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* About Section */}
                <div>
                    <h4 className="text-lg font-semibold text-white mb-3">StormHack</h4>
                    <p className="text-sm mb-4">
                        Advanced Minecraft server security testing suite. Discover vulnerabilities before they're exploited.
                    </p>
                    <p className="text-xs">© {currentYear} MCSecTest. All rights reserved.</p>
                </div>

                {/* Quick Links */}
                <div>
                    <h5 className="text-md font-semibold text-white mb-3">Quick Links</h5>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/account" className="hover:text-accent-purple transition-colors">My Account</Link></li>
                        <li><Link to="/servers" className="hover:text-accent-purple transition-colors">Server Database</Link></li>
                        <li><Link to="/#pricing" className="hover:text-accent-purple transition-colors">Pricing</Link></li> {/* Example link */}
                        <li><Link to="/blog" className="hover:text-accent-purple transition-colors">Blog</Link></li> {/* Example link */}
                    </ul>
                </div>

                {/* Community & Legal */}
                <div>
                    <h5 className="text-md font-semibold text-white mb-3">Community & Support</h5>
                    <div className="flex space-x-4 mb-4">
                        <a href={SUPPORT_LINKS.discord} target="_blank" rel="noopener noreferrer" className="hover:text-accent-blue transition-colors" aria-label="Discord"><i className="fab fa-discord fa-lg"></i></a>
                        <a href={SUPPORT_LINKS.telegram} target="_blank" rel="noopener noreferrer" className="hover:text-accent-blue transition-colors" aria-label="Telegram"><i className="fab fa-telegram-plane fa-lg"></i></a>
                        <a href={SUPPORT_LINKS.youtube} target="_blank" rel="noopener noreferrer" className="hover:text-accent-red transition-colors" aria-label="YouTube"><i className="fab fa-youtube fa-lg"></i></a>
                        {/* Add other social links */}
                    </div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/terms" className="hover:text-accent-purple transition-colors">Terms of Service</Link></li>
                        <li><Link to="/privacy" className="hover:text-accent-purple transition-colors">Privacy Policy</Link></li>
                        <li><Link to="/support" className="hover:text-accent-purple transition-colors">Support Center</Link></li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;